import { render } from "./boyaaSubjectFusion.vue?vue&type=template&id=f88262e4&scoped=true"
import script from "./boyaaSubjectFusion.vue?vue&type=script&lang=js"
export * from "./boyaaSubjectFusion.vue?vue&type=script&lang=js"

import "./boyaaSubjectFusion.vue?vue&type=style&index=0&id=f88262e4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88262e4"]])

export default __exports__